<template>
  <UiTable
    :storage-id="storageId"
    :source-columns="columns"
    :rows="rows"
    :is-loading="isLoading"
    :pagination="{
      'page-index': page,
      'page-size': pageSize,
      layout: ['total', 'prev', 'next', 'pager', 'sizer'],
    }"
    :total="total"
    v-on="paginationListeners"
  />
</template>

<script>
import { ApplicationsService } from '@/services/applications.service'
import { redirectIfDenied } from '@/services/ability.service'
import syncQuery from '@/mixins/syncUrlQuery'
import UiTable from '@/components/table/UiTable.vue'
import tableDefaults from '@/components/table/tableDefaults'
import columns from './columns'
import errorTextes from './errorText'

export default {
  components: { UiTable },
  mixins: [syncQuery, tableDefaults, columns],
  data() {
    return {
      storageId: 'applications-table',
    }
  },
  watch: {
    /**
     * Watch changes query paremeters for update table data.
     */
    '$route.query': {
      handler: 'getAppList',
      immediate: true,
    },
  },
  mounted() {
    this.syncQuery({ localField: 'pageSize', queryField: 'pageSize', query2local: (v) => +v })
    this.syncQuery({ localField: 'page', queryField: 'page', query2local: (v) => +v })
    this.syncQuery(['sort'])

    this.getTariffLists()
  },
  beforeDestroy() {
    this.rows = []
  },
  methods: {
    /**
     * Change tariffs list to array with transformed fields.
     * Transformation needs for correct print in popup filter window.
     *
     * @param {Array} source list from backend response.
     *
     * @returns {Array} mapped array with transformed fields.
     */
    transform(list) {
      if (!list) return

      return list.map((item) => {
        return {
          value: item.id,
          label: item.name,
        }
      })
    },

    /**
     * Send request to backend for get list of Applications.
     *
     * @returns {Object} data Response wrapper. Contains `content` and `total` parameters.
     * */
    async getAppList() {
      this.isLoading = true

      try {
        const { data } = await ApplicationsService.getList(this.colletQueryParams())

        this.rows = data.content.map((record) => Object.freeze(record))
        this.total = data.total

        this.isLoading = false
      } catch (e) {
        let message = e.message;
        if (!message)
        {
          message = errorTextes[e.status]
        }
        this.$store.commit('toast/NEW', { type: 'error', message: message, e })
        this.error = message
        this.isLoading = false

        redirectIfDenied.call(this, e)
      }
    },

    /**
     * Send requests to backend for get tariffs list.
     * If tariff arrays are stored, then return.
     *
     * @returns {Void} store transformed tariff arrays in vuex.
     * */
    async getTariffLists() {
      if (this.$store.getters['tariffs/hasCardAndCode']) return

      this.isLoading = true
      try {
        const code = await ApplicationsService.getTariff({ type: 'tariffs' })
        const card = await ApplicationsService.getTariff({ type: 'tariffscard' })

        this.$store.commit('tariffs/SET_TARIFF_LIST_CODE', this.transform(code.data.content))
        this.$store.commit('tariffs/SET_TARIFF_LIST_CARD', this.transform(card.data.content))
      } catch (e) {
        let message = e.message;
        if (!message)
        {
          message = errorTextes[e.status]
        }
        this.$store.commit('toast/NEW', { type: 'error', message: message , e })
        this.error = message

        redirectIfDenied.call(this, e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
